import { router } from 'expo-router';
import { isWeb } from 'shared/constants/platform';

export const zendeskArticleIds = Object.freeze({
  BELIEVE_MOVE_YOUR_PAYMENT: 10263037076116,
  CASH_DEPOSIT: 115011614388,
  DIRECT_DEPOSIT: 21994570645012,
  DEBIT_CARD: 21992844450836,
  TAX_FORMS: 360039664151,
  DEPOSIT_CASH: 115011614388,
  MY_VARO_DISPUTES: 360000752383,
  TRANSFER_MONEY: 4408009819156,
  VARO_TO_ANYONE: 4408008433428,
  DIRECT_DEPOSIT_MOVEMONEY: 115011460367,
  MOBILE_CHECK_DEPOSIT: 115011614328,
  DEPOSIT_CASH_MOVEMONEY: 115011614388,
  ZELLE: 10407152963220,
  LOGIN_ISSUE: 12732498001300,
  VARO_TO_ANYONE_RECEIVING: 18982721784980,
  CONTACT_US: 360000334946,
  ADVANCE_REPAYMENT: 4408021364500,
  DEPOSIT_CHECK_AVAILABILITY: 360001176523,
  INTERNATIONAL_TRAVEL: 21998473318932,
  CREDIT_SCORE_QUESTIONS: 15341983822868,
  REFERRAL_BONUS: 4410488362516,
  SOCIAL_MEDIA_SWEEPSTAKES_AND_SCAM_PREVENTION: 21995137968788,
  VARO_LINE_OF_CREDIT: 24961923860628,
  CHECK_DEPOSIT_FAQ: 115011614328,
  APPLYING_FOR_BELIEVE: 21994649594772,
  CURRENT_APY: 21994196784788,
  ADVANCE_ELIGIBILITY_REQUIREMENTS: 20665927540628,
  CASHBACK: 4408022239508,
  VARO_BELIEVE: 21994709061652,
  CANCELING_A_VARO_TO_ANYONE_PAYMENT: 18982566403348,
  BUILDING_YOUR_CREDIT_SCORE_WITH_VARO: 15342060208788,
  CREDIT_SCORE_TRACKING: 15342121791764,
  VARO_LINE_OF_CREDIT_ELIGIBILITY_AND_APPLICATION: 27234190222484,
  VARO_LINE_OF_CREDIT_BORROW: 27234422960148,
  VARO_LINE_OF_CREDIT_REPAYMENT: 27234452048532,
  ACCEPTED_DEPOSIT_CHECK_TYPES: 21994855237908,
  DEPOSIT_CHECK_LIMITS: 21994999526420,
  VARO_ADVANCE_FEES: 20666259418644,
  VARO_ADVANCE_LIMITS: 4408021353108,
  BELIEVE_MONEY_MOVEMENT: 21994780060692,
  BELIEVE_PAYMENTS: 21994840396436,
  BELIEVE_AND_YOUR_CREDIT_SCORE: 21994846007828,
  ATMS: 20674465873940,
  ACCESSIBILITY: 21991686854548,
  NON_CUSTOMER_SUPPORT: 21991755876116,
  APP_NAVIGATION_BASICS: 21992782107412,
  MANAGE_YOUR_CARD: 21992990408084,
  SYSTEM_REQUIREMENTS: 21992993901076,
  ROUTING_AND_ACCOUNT_NUMBER: 21993040970900,
  APPLYING_FOR_A_VARO_BANK_ACCOUNT: 21993195012628,
  IDENTITY_VERIFICATION: 21993456587284,
  ACTIVATING_YOUR_VARO_CARD: 21993499648916,
  SAVINGS_TRANSFERS: 21993909789204,
  SAVE_YOUR_CHANGE: 21993952790036,
  SAVINGS_APPLICATION: 21994032345236,
  SAVE_YOUR_PAY: 21994043313940,
  DISPUTING_CREDIT_REPORT_ERRORS: 21994704803604,
  DEPOSIT_SWEEP_PROGRAM: 21995122751892,
  UNAUTHORIZED_ACCOUNT_ACCESS: 21995233434516,
  INSTANT_TRANSFERS: 21995236196372,
  SECURED_AND_INSURED: 21995305245460,
  DEVICE_SECURITY: 21995380252308,
  STOP_SCHEDULED_PAYMENT: 21998369686164,
  MOBILE_AND_DIGITAL_WALLETS: 21998422370836,
  DISPUTES_LIFECYCLE: 21999302251924,
  DISPUTE_CREDITS: 21999369010580,
  ACCOUNT_CLOSURES: 21999920861844,
  LINKING_EXTERNAL_ACCOUNTS: 22000139030164,
  TAX_REFUNDS: 22000438000020,
  AUTHORIZATION_HOLDS: 22498319374356,
  MONEY_INSIGHTS: 24604596039828,
  UPDATE_PERSONAL_DETAILS: 4413296376596,
  // Add other articles as needed
  // ...
});

export const zendeskSectionIds = Object.freeze({
  VARO_BELIEVE: 4620367962004,
  VARO_ADVANCE_FAQ: 4620354178452,
  VARO_CREDIT_SCORE_FAQ: 15341904636052,
  VARO_VLOC_FAQ: 24961688822676,
  UNDERSTANDING_VARO_BELIEVE: 21994709061652,
  VARO_PAY_OVER_TIME_FAQ: 48421009693972,
  // Add other sections as needed
  // ...
});

export enum ZendeskSections {
  VARO_BELIEVE = zendeskSectionIds.VARO_BELIEVE,
  VARO_ADVANCE_FAQ = zendeskSectionIds.VARO_ADVANCE_FAQ,
  VARO_CREDIT_SCORE_FAQ = zendeskSectionIds.VARO_CREDIT_SCORE_FAQ,
  VARO_VLOC_FAQ = zendeskSectionIds.VARO_VLOC_FAQ,
  UNDERSTANDING_VARO_BELIEVE = zendeskSectionIds.UNDERSTANDING_VARO_BELIEVE,
  VARO_PAY_OVER_TIME_FAQ = zendeskSectionIds.VARO_PAY_OVER_TIME_FAQ,
  // Add other sections as needed
  // ...
}

export enum ZendeskArticles {
  BELIEVE_MOVE_YOUR_PAYMENT = zendeskArticleIds.BELIEVE_MOVE_YOUR_PAYMENT,
  CASH_DEPOSIT = zendeskArticleIds.CASH_DEPOSIT,
  DIRECT_DEPOSIT = zendeskArticleIds.DIRECT_DEPOSIT,
  DEBIT_CARD = zendeskArticleIds.DEBIT_CARD,
  TAX_FORMS = zendeskArticleIds.TAX_FORMS,
  DEPOSIT_CASH = zendeskArticleIds.DEPOSIT_CASH,
  MY_VARO_DISPUTES = zendeskArticleIds.MY_VARO_DISPUTES,
  LOGIN_ISSUE = zendeskArticleIds.LOGIN_ISSUE,
  CONTACT_US = zendeskArticleIds.CONTACT_US,
  ADVANCE_REPAYMENT = zendeskArticleIds.ADVANCE_REPAYMENT,
  CHECK_DEPOSIT_FAQ = zendeskArticleIds.CHECK_DEPOSIT_FAQ,
  APPLYING_FOR_BELIEVE = zendeskArticleIds.APPLYING_FOR_BELIEVE,
  VARO_TO_ANYONE_RECEIVING = zendeskArticleIds.VARO_TO_ANYONE_RECEIVING,
  TRANSFER_MONEY = zendeskArticleIds.TRANSFER_MONEY,
  VARO_TO_ANYONE = zendeskArticleIds.VARO_TO_ANYONE,
  DIRECT_DEPOSIT_MOVEMONEY = zendeskArticleIds.DIRECT_DEPOSIT_MOVEMONEY,
  ZELLE = zendeskArticleIds.ZELLE,
  CURRENT_APY = zendeskArticleIds.CURRENT_APY,
  ADVANCE_ELIGIBILITY_REQUIREMENTS = zendeskArticleIds.ADVANCE_ELIGIBILITY_REQUIREMENTS,
  CASHBACK = zendeskArticleIds.CASHBACK,
  VARO_BELIEVE = zendeskArticleIds.VARO_BELIEVE,
  INTERNATIONAL_TRAVEL = zendeskArticleIds.INTERNATIONAL_TRAVEL,
  CREDIT_SCORE_QUESTIONS = zendeskArticleIds.CREDIT_SCORE_QUESTIONS,
  SOCIAL_MEDIA_SWEEPSTAKES_AND_SCAM_PREVENTION = zendeskArticleIds.SOCIAL_MEDIA_SWEEPSTAKES_AND_SCAM_PREVENTION,
  VARO_LINE_OF_CREDIT = zendeskArticleIds.VARO_LINE_OF_CREDIT,
  CANCELING_A_VARO_TO_ANYONE_PAYMENT = zendeskArticleIds.CANCELING_A_VARO_TO_ANYONE_PAYMENT,
  BUILDING_YOUR_CREDIT_SCORE_WITH_VARO = zendeskArticleIds.BUILDING_YOUR_CREDIT_SCORE_WITH_VARO,
  CREDIT_SCORE_TRACKING = zendeskArticleIds.CREDIT_SCORE_TRACKING,
  VARO_LINE_OF_CREDIT_ELIGIBILITY_AND_APPLICATION = zendeskArticleIds.VARO_LINE_OF_CREDIT_ELIGIBILITY_AND_APPLICATION,
  VARO_LINE_OF_CREDIT_BORROW = zendeskArticleIds.VARO_LINE_OF_CREDIT_BORROW,
  VARO_LINE_OF_CREDIT_REPAYMENT = zendeskArticleIds.VARO_LINE_OF_CREDIT_REPAYMENT,
  ACCEPTED_DEPOSIT_CHECK_TYPES = zendeskArticleIds.ACCEPTED_DEPOSIT_CHECK_TYPES,
  DEPOSIT_CHECK_LIMITS = zendeskArticleIds.DEPOSIT_CHECK_LIMITS,
  VARO_ADVANCE_FEES = zendeskArticleIds.VARO_ADVANCE_FEES,
  VARO_ADVANCE_LIMITS = zendeskArticleIds.VARO_ADVANCE_LIMITS,
  BELIEVE_MONEY_MOVEMENT = zendeskArticleIds.BELIEVE_MONEY_MOVEMENT,
  BELIEVE_PAYMENTS = zendeskArticleIds.BELIEVE_PAYMENTS,
  BELIEVE_AND_YOUR_CREDIT_SCORE = zendeskArticleIds.BELIEVE_AND_YOUR_CREDIT_SCORE,
  ATMS = zendeskArticleIds.ATMS,
  ACCESSIBILITY = zendeskArticleIds.ACCESSIBILITY,
  NON_CUSTOMER_SUPPORT = zendeskArticleIds.NON_CUSTOMER_SUPPORT,
  APP_NAVIGATION_BASICS = zendeskArticleIds.APP_NAVIGATION_BASICS,
  MANAGE_YOUR_CARD = zendeskArticleIds.MANAGE_YOUR_CARD,
  SYSTEM_REQUIREMENTS = zendeskArticleIds.SYSTEM_REQUIREMENTS,
  ROUTING_AND_ACCOUNT_NUMBER = zendeskArticleIds.ROUTING_AND_ACCOUNT_NUMBER,
  APPLYING_FOR_A_VARO_BANK_ACCOUNT = zendeskArticleIds.APPLYING_FOR_A_VARO_BANK_ACCOUNT,
  IDENTITY_VERIFICATION = zendeskArticleIds.IDENTITY_VERIFICATION,
  ACTIVATING_YOUR_VARO_CARD = zendeskArticleIds.ACTIVATING_YOUR_VARO_CARD,
  SAVINGS_TRANSFERS = zendeskArticleIds.SAVINGS_TRANSFERS,
  SAVE_YOUR_CHANGE = zendeskArticleIds.SAVE_YOUR_CHANGE,
  SAVINGS_APPLICATION = zendeskArticleIds.SAVINGS_APPLICATION,
  SAVE_YOUR_PAY = zendeskArticleIds.SAVE_YOUR_PAY,
  DISPUTING_CREDIT_REPORT_ERRORS = zendeskArticleIds.DISPUTING_CREDIT_REPORT_ERRORS,
  DEPOSIT_SWEEP_PROGRAM = zendeskArticleIds.DEPOSIT_SWEEP_PROGRAM,
  UNAUTHORIZED_ACCOUNT_ACCESS = zendeskArticleIds.UNAUTHORIZED_ACCOUNT_ACCESS,
  INSTANT_TRANSFERS = zendeskArticleIds.INSTANT_TRANSFERS,
  SECURED_AND_INSURED = zendeskArticleIds.SECURED_AND_INSURED,
  DEVICE_SECURITY = zendeskArticleIds.DEVICE_SECURITY,
  STOP_SCHEDULED_PAYMENT = zendeskArticleIds.STOP_SCHEDULED_PAYMENT,
  MOBILE_AND_DIGITAL_WALLETS = zendeskArticleIds.MOBILE_AND_DIGITAL_WALLETS,
  DISPUTES_LIFECYCLE = zendeskArticleIds.DISPUTES_LIFECYCLE,
  DISPUTE_CREDITS = zendeskArticleIds.DISPUTE_CREDITS,
  ACCOUNT_CLOSURES = zendeskArticleIds.ACCOUNT_CLOSURES,
  LINKING_EXTERNAL_ACCOUNTS = zendeskArticleIds.LINKING_EXTERNAL_ACCOUNTS,
  TAX_REFUNDS = zendeskArticleIds.TAX_REFUNDS,
  AUTHORIZATION_HOLDS = zendeskArticleIds.AUTHORIZATION_HOLDS,
  MONEY_INSIGHTS = zendeskArticleIds.MONEY_INSIGHTS,
  UPDATE_PERSONAL_DETAILS = zendeskArticleIds.UPDATE_PERSONAL_DETAILS,
  // Add other articles as needed
  // ...
}

interface ZendeskInformation {
  id: number;
  title: string;
}

type ZendeskArticleObject = Record<ZendeskArticles, ZendeskInformation>;
const ZendeskArticlesMapper: ZendeskArticleObject = {
  [ZendeskArticles.BELIEVE_MOVE_YOUR_PAYMENT]: {
    id: zendeskArticleIds.BELIEVE_MOVE_YOUR_PAYMENT,
    title: '',
  },
  [ZendeskArticles.CASH_DEPOSIT]: {
    id: zendeskArticleIds.CASH_DEPOSIT,
    title: '',
  },
  [ZendeskArticles.DIRECT_DEPOSIT]: {
    id: zendeskArticleIds.DIRECT_DEPOSIT,
    title: '',
  },
  [ZendeskArticles.DEBIT_CARD]: { id: zendeskArticleIds.DEBIT_CARD, title: '' },
  [ZendeskArticles.TAX_FORMS]: { id: zendeskArticleIds.TAX_FORMS, title: '' },
  [ZendeskArticles.DEPOSIT_CASH]: {
    id: zendeskArticleIds.DEPOSIT_CASH,
    title: '',
  },
  [ZendeskArticles.MY_VARO_DISPUTES]: {
    id: zendeskArticleIds.MY_VARO_DISPUTES,
    title: '',
  },
  [ZendeskArticles.LOGIN_ISSUE]: {
    id: zendeskArticleIds.LOGIN_ISSUE,
    title: '',
  },
  [ZendeskArticles.CONTACT_US]: { id: zendeskArticleIds.CONTACT_US, title: '' },
  [ZendeskArticles.ADVANCE_REPAYMENT]: {
    id: zendeskArticleIds.ADVANCE_REPAYMENT,
    title: '',
  },
  [ZendeskArticles.CHECK_DEPOSIT_FAQ]: {
    id: zendeskArticleIds.CHECK_DEPOSIT_FAQ,
    title: '',
  },
  [ZendeskArticles.APPLYING_FOR_BELIEVE]: {
    id: zendeskArticleIds.APPLYING_FOR_BELIEVE,
    title: '',
  },
  [ZendeskArticles.VARO_TO_ANYONE_RECEIVING]: {
    id: zendeskArticleIds.VARO_TO_ANYONE_RECEIVING,
    title: '',
  },
  [ZendeskArticles.TRANSFER_MONEY]: {
    id: zendeskArticleIds.TRANSFER_MONEY,
    title: '',
  },
  [ZendeskArticles.VARO_TO_ANYONE]: {
    id: zendeskArticleIds.VARO_TO_ANYONE,
    title: '',
  },
  [ZendeskArticles.DIRECT_DEPOSIT_MOVEMONEY]: {
    id: zendeskArticleIds.DIRECT_DEPOSIT_MOVEMONEY,
    title: '',
  },
  [ZendeskArticles.ZELLE]: { id: zendeskArticleIds.ZELLE, title: '' },
  [ZendeskArticles.CURRENT_APY]: {
    id: zendeskArticleIds.CURRENT_APY,
    title: '',
  },
  [ZendeskArticles.ADVANCE_ELIGIBILITY_REQUIREMENTS]: {
    id: zendeskArticleIds.ADVANCE_ELIGIBILITY_REQUIREMENTS,
    title: '',
  },
  [ZendeskArticles.CASHBACK]: {
    id: zendeskArticleIds.CASHBACK,
    title: '',
  },
  [ZendeskSections.UNDERSTANDING_VARO_BELIEVE]: {
    id: zendeskSectionIds.UNDERSTANDING_VARO_BELIEVE,
    title: '',
  },
  [ZendeskArticles.INTERNATIONAL_TRAVEL]: {
    id: zendeskArticleIds.INTERNATIONAL_TRAVEL,
    title: '',
  },
  [ZendeskArticles.CREDIT_SCORE_QUESTIONS]: {
    id: zendeskArticleIds.CREDIT_SCORE_QUESTIONS,
    title: '',
  },
  [ZendeskArticles.SOCIAL_MEDIA_SWEEPSTAKES_AND_SCAM_PREVENTION]: {
    id: zendeskArticleIds.SOCIAL_MEDIA_SWEEPSTAKES_AND_SCAM_PREVENTION,
    title: '',
  },
  [ZendeskArticles.VARO_LINE_OF_CREDIT]: {
    id: zendeskArticleIds.VARO_LINE_OF_CREDIT,
    title: '',
  },
  [ZendeskArticles.CANCELING_A_VARO_TO_ANYONE_PAYMENT]: {
    id: zendeskArticleIds.CANCELING_A_VARO_TO_ANYONE_PAYMENT,
    title: '',
  },
  [ZendeskArticles.BUILDING_YOUR_CREDIT_SCORE_WITH_VARO]: {
    id: zendeskArticleIds.BUILDING_YOUR_CREDIT_SCORE_WITH_VARO,
    title: '',
  },
  [ZendeskArticles.CREDIT_SCORE_TRACKING]: {
    id: zendeskArticleIds.CREDIT_SCORE_TRACKING,
    title: '',
  },
  [ZendeskArticles.VARO_LINE_OF_CREDIT_ELIGIBILITY_AND_APPLICATION]: {
    id: zendeskArticleIds.VARO_LINE_OF_CREDIT_ELIGIBILITY_AND_APPLICATION,
    title: '',
  },
  [ZendeskArticles.VARO_LINE_OF_CREDIT_BORROW]: {
    id: zendeskArticleIds.VARO_LINE_OF_CREDIT_BORROW,
    title: '',
  },
  [ZendeskArticles.VARO_LINE_OF_CREDIT_REPAYMENT]: {
    id: zendeskArticleIds.VARO_LINE_OF_CREDIT_REPAYMENT,
    title: '',
  },
  [ZendeskArticles.ACCEPTED_DEPOSIT_CHECK_TYPES]: {
    id: zendeskArticleIds.ACCEPTED_DEPOSIT_CHECK_TYPES,
    title: '',
  },
  [ZendeskArticles.DEPOSIT_CHECK_LIMITS]: {
    id: zendeskArticleIds.DEPOSIT_CHECK_LIMITS,
    title: '',
  },
  [ZendeskArticles.VARO_ADVANCE_FEES]: {
    id: zendeskArticleIds.VARO_ADVANCE_FEES,
    title: '',
  },
  [ZendeskArticles.VARO_ADVANCE_LIMITS]: {
    id: zendeskArticleIds.VARO_ADVANCE_LIMITS,
    title: '',
  },
  [ZendeskArticles.BELIEVE_MONEY_MOVEMENT]: {
    id: zendeskArticleIds.BELIEVE_MONEY_MOVEMENT,
    title: '',
  },
  [ZendeskArticles.BELIEVE_PAYMENTS]: {
    id: zendeskArticleIds.BELIEVE_PAYMENTS,
    title: '',
  },
  [ZendeskArticles.BELIEVE_AND_YOUR_CREDIT_SCORE]: {
    id: zendeskArticleIds.BELIEVE_AND_YOUR_CREDIT_SCORE,
    title: '',
  },
  [ZendeskArticles.ATMS]: { id: zendeskArticleIds.ATMS, title: '' },
  [ZendeskArticles.ACCESSIBILITY]: {
    id: zendeskArticleIds.ACCESSIBILITY,
    title: '',
  },
  [ZendeskArticles.NON_CUSTOMER_SUPPORT]: {
    id: zendeskArticleIds.NON_CUSTOMER_SUPPORT,
    title: '',
  },
  [ZendeskArticles.APP_NAVIGATION_BASICS]: {
    id: zendeskArticleIds.APP_NAVIGATION_BASICS,
    title: '',
  },
  [ZendeskArticles.MANAGE_YOUR_CARD]: {
    id: zendeskArticleIds.MANAGE_YOUR_CARD,
    title: '',
  },
  [ZendeskArticles.SYSTEM_REQUIREMENTS]: {
    id: zendeskArticleIds.SYSTEM_REQUIREMENTS,
    title: '',
  },
  [ZendeskArticles.ROUTING_AND_ACCOUNT_NUMBER]: {
    id: zendeskArticleIds.ROUTING_AND_ACCOUNT_NUMBER,
    title: '',
  },
  [ZendeskArticles.APPLYING_FOR_A_VARO_BANK_ACCOUNT]: {
    id: zendeskArticleIds.APPLYING_FOR_A_VARO_BANK_ACCOUNT,
    title: '',
  },
  [ZendeskArticles.IDENTITY_VERIFICATION]: {
    id: zendeskArticleIds.IDENTITY_VERIFICATION,
    title: '',
  },
  [ZendeskArticles.ACTIVATING_YOUR_VARO_CARD]: {
    id: zendeskArticleIds.ACTIVATING_YOUR_VARO_CARD,
    title: '',
  },
  [ZendeskArticles.SAVINGS_TRANSFERS]: {
    id: zendeskArticleIds.SAVINGS_TRANSFERS,
    title: '',
  },
  [ZendeskArticles.SAVE_YOUR_CHANGE]: {
    id: zendeskArticleIds.SAVE_YOUR_CHANGE,
    title: '',
  },
  [ZendeskArticles.SAVINGS_APPLICATION]: {
    id: zendeskArticleIds.SAVINGS_APPLICATION,
    title: '',
  },
  [ZendeskArticles.SAVE_YOUR_PAY]: {
    id: zendeskArticleIds.SAVE_YOUR_PAY,
    title: '',
  },
  [ZendeskArticles.DISPUTING_CREDIT_REPORT_ERRORS]: {
    id: zendeskArticleIds.DISPUTING_CREDIT_REPORT_ERRORS,
    title: '',
  },
  [ZendeskArticles.DEPOSIT_SWEEP_PROGRAM]: {
    id: zendeskArticleIds.DEPOSIT_SWEEP_PROGRAM,
    title: '',
  },
  [ZendeskArticles.UNAUTHORIZED_ACCOUNT_ACCESS]: {
    id: zendeskArticleIds.UNAUTHORIZED_ACCOUNT_ACCESS,
    title: '',
  },
  [ZendeskArticles.INSTANT_TRANSFERS]: {
    id: zendeskArticleIds.INSTANT_TRANSFERS,
    title: '',
  },
  [ZendeskArticles.SECURED_AND_INSURED]: {
    id: zendeskArticleIds.SECURED_AND_INSURED,
    title: '',
  },
  [ZendeskArticles.DEVICE_SECURITY]: {
    id: zendeskArticleIds.DEVICE_SECURITY,
    title: '',
  },
  [ZendeskArticles.STOP_SCHEDULED_PAYMENT]: {
    id: zendeskArticleIds.STOP_SCHEDULED_PAYMENT,
    title: '',
  },
  [ZendeskArticles.MOBILE_AND_DIGITAL_WALLETS]: {
    id: zendeskArticleIds.MOBILE_AND_DIGITAL_WALLETS,
    title: '',
  },
  [ZendeskArticles.DISPUTES_LIFECYCLE]: {
    id: zendeskArticleIds.DISPUTES_LIFECYCLE,
    title: '',
  },
  [ZendeskArticles.DISPUTE_CREDITS]: {
    id: zendeskArticleIds.DISPUTE_CREDITS,
    title: '',
  },
  [ZendeskArticles.ACCOUNT_CLOSURES]: {
    id: zendeskArticleIds.ACCOUNT_CLOSURES,
    title: '',
  },
  [ZendeskArticles.LINKING_EXTERNAL_ACCOUNTS]: {
    id: zendeskArticleIds.LINKING_EXTERNAL_ACCOUNTS,
    title: '',
  },
  [ZendeskArticles.TAX_REFUNDS]: {
    id: zendeskArticleIds.TAX_REFUNDS,
    title: '',
  },
  [ZendeskArticles.AUTHORIZATION_HOLDS]: {
    id: zendeskArticleIds.AUTHORIZATION_HOLDS,
    title: '',
  },
  [ZendeskArticles.MONEY_INSIGHTS]: {
    id: zendeskArticleIds.MONEY_INSIGHTS,
    title: '',
  },
  [ZendeskArticles.UPDATE_PERSONAL_DETAILS]: {
    id: zendeskArticleIds.UPDATE_PERSONAL_DETAILS,
    title: '',
  },
  // Add other articles as needed
  // ...
};
type ZendeskSectionObject = Record<ZendeskSections, ZendeskInformation>;
export const ZendeskSectionsMapper: ZendeskSectionObject = {
  [ZendeskSections.VARO_BELIEVE]: {
    id: zendeskSectionIds.VARO_BELIEVE,
    title: '',
  },
  [ZendeskSections.VARO_ADVANCE_FAQ]: {
    id: zendeskSectionIds.VARO_ADVANCE_FAQ,
    title: '',
  },
  [ZendeskSections.VARO_CREDIT_SCORE_FAQ]: {
    id: zendeskSectionIds.VARO_CREDIT_SCORE_FAQ,
    title: '',
  },
  [ZendeskSections.VARO_VLOC_FAQ]: {
    id: zendeskSectionIds.VARO_VLOC_FAQ,
    title: '',
  },
  // Add other sections as needed
  // ...
};

export const ZENDESK_URL = 'https://support.varomoney.com/hc/en-us';
export const getFaqSectionUrl = (section: ZendeskSections) =>
  `${ZENDESK_URL}/sections/${section}`;
export const getFaqArticleUrl = (article: ZendeskArticles) =>
  `${ZENDESK_URL}/articles/${article}`;

export const showZendeskFAQ = () => {
  if (isWeb) {
    window.open(ZENDESK_URL, '_blank');

    return;
  }
  router.push({
    pathname: '/zendesk/all-faq',
    params: {
      title: '',
    },
  });
};

export const showZendeskSection = (section: ZendeskSections) => {
  const sectionInfo = ZendeskSectionsMapper[section];
  if (!sectionInfo) {
    return;
  }
  if (isWeb) {
    window.open(getFaqSectionUrl(section), '_blank');
    return;
  }
  router.push({
    pathname: '/zendesk/section',
    params: {
      id: sectionInfo.id,
      title: sectionInfo.title,
    },
  });
};

export const showZendeskArticle = (article: ZendeskArticles) => {
  const articleInfo = ZendeskArticlesMapper[article];
  if (!articleInfo) {
    return;
  }

  if (isWeb) {
    window.open(getFaqArticleUrl(article), '_blank');
    return;
  }
  router.push({
    pathname: '/zendesk/article',
    params: {
      id: articleInfo.id,
      title: articleInfo.title,
    },
  });
};
